var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main"},[_c('div',{staticClass:"home"},[_c('div',{staticClass:"downDiv"},[_c('van-button',{staticClass:"download",on:{"click":_vm.download}},[_vm._v(" 前往微信打开 ")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }